module.exports = __webpack_public_path__ + "img/small-storage.e413cb67.svg";